import { Directive, OnInit, inject, input, signal } from '@angular/core';

import { Observable } from 'rxjs';

import { CamBaseComponent } from '@camelot/utils';

import { CamCalendarData } from '../models/calendar/data';
import { CamPanningsDataService } from '../services/instances.service';

@Directive()
export abstract class AbstractCalendarComponent extends CamBaseComponent implements OnInit {
  planningId = input.required<string>();

  readonly isReady = signal(false);

  protected _calendar!: CamCalendarData;

  private _dataService = inject(CamPanningsDataService);

  ngOnInit() {
    this._calendar = this._dataService.getCalendar(this.planningId(), true);
    this._registerSubscription(
      this._calendar.ready$.subscribe({
        next: ready => this.isReady.set(ready),
      })
    );
  }

  public getIsReady$(): Observable<boolean> {
    return this._calendar.ready$;
  }
}
